import React, {useEffect} from 'react';
import {ActivityIndicator, StyleSheet, View} from 'react-native';
import {CommonActions, useNavigation} from '@react-navigation/native';
import {useAuth} from '../../../context/auth';
import {verificarElegibilidade} from '../../../services/creditoMova';

type Destination = 'tab' | 'simular';

function EmprestimoDeeplinkGateway({destination}: {destination: Destination}) {
  const {isLogged, isAuthReady, setIsEmprestimoEligible} = useAuth();
  const navigation = useNavigation();

  useEffect(() => {
    if (!isAuthReady) {
      return;
    }

    if (!isLogged) {
      navigation.dispatch(
        CommonActions.reset({index: 0, routes: [{name: 'Home'}]}),
      );
      return;
    }

    (async () => {
      try {
        const {elegivel} = await verificarElegibilidade();

        if (!elegivel) {
          navigation.dispatch(
            CommonActions.reset({index: 0, routes: [{name: 'Home'}]}),
          );
          return;
        }

        setIsEmprestimoEligible(true);

        if (destination === 'simular') {
          navigation.dispatch(
            CommonActions.reset({
              index: 1,
              routes: [{name: 'Home'}, {name: 'EmprestimoSimulacao'}],
            }),
          );
        } else {
          navigation.dispatch(
            CommonActions.reset({
              index: 0,
              routes: [
                {
                  name: 'Home',
                  state: {routes: [{name: 'Emprestimo'}]},
                },
              ],
            }),
          );
        }
      } catch {
        navigation.dispatch(
          CommonActions.reset({index: 0, routes: [{name: 'Home'}]}),
        );
      }
    })();
  }, [isAuthReady, isLogged]);

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {flex: 1, justifyContent: 'center', alignItems: 'center'},
});

export const EmprestimosGateway = () => (
  <EmprestimoDeeplinkGateway destination="tab" />
);

export const SimularGateway = () => (
  <EmprestimoDeeplinkGateway destination="simular" />
);
